export default __webpack_public_path__ + "static/media/frutiger-45light.f441dd68.ttf";